var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 78,
    viewBox: "0 0 74 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 74,
    height: 78,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABOCAYAAACHQYBnAAADL0lEQVR4nO3czXGbUBSG4VeM96YDlB3DSiXIFcSpQOnAJciqwE4FmlQQdWB1EK0YdhEVhBKyADw4FtIB7g9I59t5gAs8RliYe86MESTN8jnwCETAAjgCObBL4ujg7cAamfnceZrlC+AFWJ5ZbQ9skjjaOzik1niDSrP8O7DtsMkmiaNnO0dzOV6geiDV8YblHKq6H/0ZMMSDj49h4HqHwNrz9r3i9IpKszwE/hoY6ksSR0cD44jj+opaGhrn0dA44riGWhgaJzQ0jjg+7lGTjEIJo1DCKJQwCiWMQgmjUMIolDAKJYxCCaNQwiiUMAoljEIJo1DCKJQwCiWMQgmjUMIolDAKJYxCCaNQwty1LUizfMnnF5Z739NvTKTl3A5JHO3atvkElWb5M/DE6ZeM6zTLC8pZJa+9j9RTqlk0a2DesrwAfgCvSRwVzWV3jZVC4I3Lb3ND4CXN8hXlzJLiwvreU53blsuv4kNKyK9pln9rzm8IGgNJkJpZAG/VtqNN49y6zFdYAL+b51bfzLf0mxcwaqyeF0CdEPhV/xBUN7Yhs0NGiTUQqc6y8iEAVgaOa1RYhpDqPEEJtTQwGIwEyzASVJ+2gJY/lT3jFcsCUj3u3MY3cy9YtpCqWIECx1iWkQCOAWU5hY04wXKAVCRxdAwoSyhsxSqWAySofAJgY3EnYAnLERKUz34E1fOM7QfcBeVJ3Rsa7x43SLv6vyUzcPrbmVIONB763ysXFOtDPiDBfyUeigWcQIITtTA3jnUSCVqKhm4UqxUJzlRX3RjWWSS4UIZ2I1gXkUBQr3flWCIkEBY2XimWGAk6VIBeGVYnJOhYKnslWJ2RoEdN8cSxeiFBz+LriWL1RoIBVeoTwxqEBAPL+SeCNRgJDPQ9GDmWESQw1CBipFjGkMBgJ42RYRlFAsMtR0aCZRwJLPRm8YxlBQksNbHxhGUNCSx2+3GMZRUJLLdFcoRlHQkc9I+yjOUECRw12rKE5QwJHHYkM4zlFAn8tG4biuUcCfx0TRyC5QUJ/PXh7IPlDQk8FQ1VJ/sA7ISb7PBcJeG1VzC8F/CsKGffNudQFZRAP8dQqPQPeIR40U7R2loAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.a94bf8b37c45827be0651cd7ebe7fce2.svg";
export { ForwardRef as ReactComponent };